import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 570px;
  width: 100%;
`;

export const DescriptionsPlaceholder = styled.div`
  width: 100%;
  height: 118px;
`;

export const Space = styled.div`
  height: 30px;
`;
